// Checklist step links are authored in constance as absolute production URLs (e.g.
// https://dashboard.truv.com/app/customization/templates). Anything pointing back into this SPA
// should route client-side in the same tab rather than opening a new one, so the user stays in
// their session instead of booting a second copy of the dashboard.
//
// Matching is by *path namespace*, not host: the catalog names the production host, but the same
// entry has to route correctly on localhost and staging too, so only the path is ever used.
const APP_ROUTE_PREFIX = '/app/';

export function toInternalPath(href: string | null | undefined): string | null {
  if (!href) {
    return null;
  }
  // Already a route — allows the catalog to be simplified to relative paths later.
  if (href.startsWith(APP_ROUTE_PREFIX)) {
    return href;
  }
  try {
    const parsed = new URL(href);
    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
      return null;
    }
    // Same origin covers every environment; the truv.com check covers the catalog naming the
    // production dashboard while the app runs on localhost or staging. docs.truv.com is excluded
    // by the path prefix, since its pages live under /docs/.
    const isThisApp = parsed.origin === window.location.origin || parsed.hostname.endsWith('.truv.com');
    if (!(isThisApp && parsed.pathname.startsWith(APP_ROUTE_PREFIX))) {
      return null;
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return null;
  }
}
